import React, { useState, useEffect, useRef } from 'react';
import AvatarEditor from 'react-avatar-editor';

import { IconRotate, IconZoomIn } from '@tabler/icons';

import dataURLtoFile from '../../utils/dataURLToFile';
import { useAuth } from '../../hooks/auth';

import { Container, Slider, ButtonRow } from './styles';

interface AvatarModalProps {
  selectedImage: string | File;
  getResult: (url: string | File | Blob) => void;
}

const AvatarModal: React.FC<AvatarModalProps> = ({
  selectedImage,
  getResult,
}) => {
  const [image, setImage] = useState<File | any>();
  const [rotation, setRotation] = useState(0);
  const [scale, setScale] = useState(1.2);

  const { user } = useAuth();
  const editorRef = useRef<any>(null);

  useEffect(() => {
    setImage(selectedImage);
  }, [selectedImage]);

  const generateResult = async () => {
    if (editorRef) {
      const imageURL = editorRef.current?.getImageScaledToCanvas().toDataURL();

      const imageFile = dataURLtoFile(
        imageURL,
        `${user.id}.${image.name.split('.')[1]}`,
      );

      getResult(imageFile);
      setImage('');
    }
  };

  return (
    <Container
      style={{
        transform: image ? 'translateY(0px)' : 'translateY(30px)',
        visibility: image ? 'visible' : 'hidden',
        opacity: image ? 1 : 0,
      }}
    >
      <div>
        <h1>Recortar imagem</h1>
        <p>Arraste para ajustar à seleção</p>
      </div>

      <AvatarEditor
        ref={editorRef}
        image={image}
        width={200}
        height={200}
        border={75}
        color={[0, 0, 0, 0.85]}
        scale={scale}
        rotate={rotation}
      />

      <section>
        <Slider>
          <label>
            <IconZoomIn size={20} />
          </label>
          <input
            name="zoom"
            type="range"
            min="1"
            max="2"
            step="any"
            value={scale}
            onChange={(e: any) => setScale(e.target.value)}
          />
        </Slider>
        <Slider>
          <label>
            <IconRotate size={20} />
          </label>
          <input
            name="rotation"
            type="range"
            min="-180"
            max="180"
            step="any"
            value={rotation}
            onChange={(e: any) => setRotation(e.target.value)}
          />
        </Slider>

        <ButtonRow>
          <button type="button" onClick={() => setImage('')}>
            Cancelar
          </button>
          <button type="button" onClick={generateResult}>
            Salvar
          </button>
        </ButtonRow>
      </section>
    </Container>
  );
};

export default AvatarModal;
